import { T_MongoDoc, T_MongoId } from "types/_utils.types";
import { T_AffiliatePlan } from "./affiliate.plan.dto";
import { OrganisationDto } from "./organisation.dto";

export enum RoleTypes {
  SUPERADMIN = "Superadmin",
  ADMIN = "Admin",
  LEAD_ADMIN = "Lead Admin",
  LEAD_MANAGER = "Lead Manager",
  CASE_ADMIN = "Case Admin",
  CASE_MANAGER = "Case Manager",
  CONTENT_ADMIN = "Content Admin",
  CONTENT_MANAGER = "Content Manager",
  AFFILIATE_ADMIN = "Affiliate Admin",
  AFFILIATE_MANAGER = "Affiliate Manager",
  AFFILIATE = "Affiliate",
  USER = "User",
  ADMIN_READ_ONLY = "Admin Read-Only",
  DMS_EXTERNAL = "DMS External",
  NEGOTIATOR = "Negotiator",
  ISO = "Affiliate Sales",
}

export enum SubscriptionTypes {
  FREE = "Free",
  MEMBER = "Member",
}

export type UserDto = {
  name: string;
  email: string;
  role: RoleTypes;
  password: string;
  last_login: Date;
  is_verified: boolean;
  profile_image: string;
  slug: string;
  subscription_status: SubscriptionTypes;
  avatar_url: string;
  liked_posts: T_MongoId[];
  liked_comments: T_MongoId[];
  saved_blogs: T_MongoId[];
  is_banned: boolean;
  affiliate_code: string;
  affiliate_model?: {
    category: string;
    plan: T_AffiliatePlan;
  };
  organisation?: T_MongoId;
  sub_organisations?: { organisation: OrganisationDto; permission: string }[];
  assigned_to?: T_MongoId;
  phone?: {
    number: string;
    code: string;
    verified: boolean;
  };
  otp?: {
    code: string;
    expires_at: Date;
    no_of_attempts: number;
    next_allowed_request_at: Date;
  };
} & T_MongoDoc;

export type UserSchemaDto = UserDto & T_MongoDoc;
export type CreateUserDto = UserDto;
export type UpdateUser = Partial<UserDto>;
